import React from 'react';
import CallContainer from '../../components/CallContainer';
import TrackerSection from './TrackerSection/TrackerSection';

const ExpressTrackerLayout = () => {
  return (
    <>
      <TrackerSection />
      <CallContainer />
    </>
  );
};

export default ExpressTrackerLayout;
